const CheckboxTick = () => (
    <svg
        width='26'
        height='24'
        viewBox='0 0 26 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M21.1014 0.948933C21.3075 0.858903 21.4804 0.858853 21.602 1.00009C22.8338 2.43066 24.2296 5.05422 24.8114 6.14773C24.8899 6.29527 24.9535 6.41495 25 6.50009C25.0572 6.60487 25.0988 6.71268 25.1266 6.82325L10.9749 20.975L8.5 23.4498L6.02513 20.975L0.340941 15.2908C0.118224 14.3973 0 13.4625 0 12.5001C0 10.3633 0.582768 8.36265 1.59803 6.64837L8.5 13.5503L21.1014 0.948933Z'
            fill='white'
        />
    </svg>
);

export default CheckboxTick;
